import { Star } from "lucide-react";
import { Rail } from "./Rail";
import { REVIEWS, GOOGLE_REVIEWS_URL, GOOGLE_RATING } from "@/lib/business";

const Stars = ({ size = 16 }) => (
  <div className="flex gap-0.5 text-[#f5b301]" aria-label="5 Sterne">
    {Array.from({ length: 5 }, (_, i) => <Star key={i} size={size} fill="currentColor" strokeWidth={0} />)}
  </div>
);

const ReviewCard = ({ r }) => (
  <figure className="w-[280px] sm:w-[340px] md:w-[400px] shrink-0 bg-white border border-ink/10 p-5 sm:p-7 flex flex-col shadow-[0_10px_30px_-18px_rgba(15,31,56,0.35)] transition-transform hover:-translate-y-1">
    <Stars />
    <blockquote className="mt-3 sm:mt-4 text-sm sm:text-[15px] leading-relaxed flex-1">„{r.text}“</blockquote>
    <figcaption className="mt-5 sm:mt-6 flex items-center gap-3">
      <span className="flex h-9 w-9 items-center justify-center rounded-full bg-plate text-white font-bold">{r.author[0]}</span>
      <span>
        <span className="block font-semibold">{r.author}</span>
        <span className="lb text-inkmuted">Google-Bewertung</span>
      </span>
    </figcaption>
  </figure>
);

export const Reviews = () => (
  <section id="bewertungen" className="shade-muted edge-shadow text-ink py-14 sm:py-24 md:py-32 overflow-hidden">
    <Rail label="03 · Google-Bewertungen" className="!py-0">
      <div className="flex flex-wrap items-end justify-between gap-5 sm:gap-6">
        <h2 className="dp pc-h2">Das sagen <span className="text-plate">meine Kunden.</span></h2>
        <a href={GOOGLE_REVIEWS_URL} target="_blank" rel="noopener noreferrer"
          className="inline-flex items-center gap-3 sm:gap-4 bg-navy text-paper px-4 py-3 sm:px-6 sm:py-4 transition-colors hover:bg-plate" data-testid="reviews-rating-badge">
          <span className="dp text-3xl sm:text-4xl tn whitespace-nowrap">{GOOGLE_RATING.score}<span className="text-steel text-xl sm:text-2xl"> / 5</span></span>
          <span><Stars size={14} /><span className="lb text-[10px] sm:text-xs text-steel block mt-1">{GOOGLE_RATING.count} Bewertungen auf Google</span></span>
        </a>
      </div>
    </Rail>
    <div className="mt-8 sm:mt-14 [mask-image:linear-gradient(to_right,transparent,black_5%,black_95%,transparent)]" data-testid="reviews-list">
      <div className="mq mq-slow gap-4 sm:gap-6 pr-4 sm:pr-6 py-2 hover:[animation-play-state:paused]">
        {[...REVIEWS, ...REVIEWS].map((r, i) => <ReviewCard key={i} r={r} />)}
      </div>
    </div>
    <div className="max-w-6xl mx-auto px-5 sm:px-6 md:pl-[calc(220px+3rem+1.5rem)] mt-8 sm:mt-10">
      <a href={GOOGLE_REVIEWS_URL} target="_blank" rel="noopener noreferrer"
        className="lb text-[11px] sm:text-xs flex sm:inline-flex justify-center items-center gap-2 rounded-full sm:rounded-none border-2 border-ink px-5 sm:px-6 py-3.5 sm:py-4 transition-colors hover:bg-ink hover:text-paper" data-testid="reviews-google-link">
        Alle Bewertungen auf Google ansehen →
      </a>
    </div>
  </section>
);
